<template>
  <div id="job">
    <router-view/>
  </div>
</template>

<script>
export default {
  mounted () {
  }
}
</script>

<style scoped>
#job {
  display: flex;
  flex-direction: column;
  width: 1140px;
  margin: auto;
}

.mobile_wrap #job {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/job/Job.vue